// API配置文件
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://back.dutyc.top/api';

// API端点配置
export const API_ENDPOINTS = {
  LOGIN: `${API_BASE_URL}/login.php`,
  REGISTER: `${API_BASE_URL}/register.php`,
  VIDEOS: `${API_BASE_URL}/videos.php`,
  COMMENTS: `${API_BASE_URL}/comments.php`,
  USERS: `${API_BASE_URL}/users.php`,
  INVITE_CODES: `${API_BASE_URL}/invite_codes.php`,
  USER_VIDEOS: `${API_BASE_URL}/user_videos.php`
};

// API请求封装
export const apiRequest = async (url, options = {}) => {
  try {
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers
      },
      ...options
    });
    
    return response;
  } catch (error) {
    console.error('API请求失败:', error);
    throw error;
  }
};

export default API_BASE_URL;